/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_Quick_Action_TitleInputs */

const de_device_quick_action_title = /** @type {(inputs: Device_Quick_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbundene Geräte verwalten`)
};

/** @type {(inputs: Device_Quick_Action_TitleInputs) => LocalizedString} */
const en_device_quick_action_title = de_device_quick_action_title;

/**

* @param {Device_Quick_Action_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const device_quick_action_title = /** @type {((inputs?: Device_Quick_Action_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_Quick_Action_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_device_quick_action_title(inputs)
	return en_device_quick_action_title(inputs)
});